export function requestRecebimentos(params) {
	return {
		type: '@clientRecebimentos/REQUEST',
		payload: { params },
	};
}

export function successRecebimentos(dados) {
	return {
		type: '@clientRecebimentos/SUCCESS',
		payload: { dados },
	};
}

export function failureRecebimentos(error) {
	return {
		type: '@clientRecebimentos/FAILURE',
		payload: { error },
	};
}
